import { sensorStatusNameApi, SensorStatusNameDTO } from "../api/sensorStatusNameApi";
import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";

const initialState: SensorStatusNameDTO[] = [];

const sensorStatusNameSlice = createSlice({
    name: "sensorStatusName",
    initialState,
    reducers: {
        setSensorStatusName: (state, action: PayloadAction<SensorStatusNameDTO[]>) => {
            return action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(sensorStatusNameApi.endpoints.getSensorStatusName.matchFulfilled, (state, action) => {
            return action.payload;
        })
    }
})

export const { setSensorStatusName } = sensorStatusNameSlice.actions;
export default sensorStatusNameSlice.reducer;